import { Outlet, Navigate, useLocation } from "react-router-dom";
import { useRef } from "react";
import { useAuth } from "@/context/AuthContext";
import ManagementNav from "../components/ManagementNav";
import AnimatedBackground from "../components/AnimatedBackground";
import { motion, AnimatePresence } from "framer-motion";
import ScrollProgress from "@/components/ScrollProgress";

export default function ManagementLayout() {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen bg-zinc-900 flex items-center justify-center">
        <div className="w-8 h-8 border-2 border-amber-400 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/drivershub/login" replace />;
  }

  const isFullPage = ["/drivershub/karte", "/drivershub/chat", "/drivershub/profil"].includes(location.pathname) || location.pathname.startsWith("/drivershub/fahrer/");
  const scrollRef = useRef(null);

  return (
    <div className="h-screen overflow-hidden bg-transparent" key={user.user_id}>
      <AnimatedBackground />
      {!isFullPage && <ScrollProgress target={scrollRef} className="z-[110]" />}
      <ManagementNav />
      <main className="relative z-10 h-screen transition-all duration-300 ease-in-out">
        <AnimatePresence mode="wait">
          <motion.div
            key={location.pathname}
            initial={{ opacity: 0 }}
            animate={{
              opacity: 1,
              transition: { duration: 0.16, ease: [0.16, 1, 0.3, 1] }
            }}
            exit={{
              opacity: 0,
              transition: { duration: 0.08, ease: [0.32, 0, 0.67, 0] }
            }}
            className="h-full w-full"
          >
            {isFullPage ? (
              <Outlet />
            ) : (
              <div ref={scrollRef} className="h-full w-full overflow-y-auto no-scrollbar pt-20 lg:pt-24 pb-10 px-4 sm:px-6 lg:px-8">
                <Outlet />
              </div>
            )}
          </motion.div>
        </AnimatePresence>
      </main>
    </div>
  );
}
